<template>
    <!--<div v-if="facet.name" class="card pt-4 border-0">
        <div class="h3 title py-0">{{ facetName }}</div>

        <div v-if="facet.type === 'price'">
            <item-filter-price></item-filter-price>
        </div>

        <div v-else class="form-check-wrapper" v-for="value in facets" :key="value.id">
            <div class="form-check mb-0 pl-0">
                <input :id="'option-' + value.id" class="form-check-input d-none" type="checkbox" :checked="isSelected(value.id)" @change="updateFacet(value)" :disabled="isLoading || value.count <= 0">
                <label :for="'option-' + value.id" class="form-check-label" :class="[paddingClasses, isSelected(value.id) ? 'bg-appearance' : '']" :style="paddingInlineStyles">
                    <div class="d-flex">
                        <span class="flex-grow-1">{{ value.name }}</span>
                        <div class="filter-badge">{{ value.count }}</div>
                    </div>
                </label>
            </div>
        </div>
    </div>-->

    <div v-if="facet.name" class="filter__item" :class="{ 'filter__item--price' : facet.type === 'price', 'd-none': facet.id === 'category' || facet.id === 'feedback' }">
        <button class="filter__headline" v-if="showHeadline" @click="()=> this.isOpen = !this.isOpen">
            <span class="filter__title">{{ facetName }}</span>
            <span class="filter__option-prev" v-show="!isOpen">
                {{ optionPreviewString }}
            </span>
            <svg class="filter__headline-icon" :class="{'filter__headline-icon--active':isOpen}">
                <use xlink:href="#svg_arrow" xmlns:xlink="https://www.w3.org/1999/xlink"></use>
            </svg>
        </button>
        <transition>
            <div v-if="facet.type === 'price'" v-show="isOpen">
                <item-filter-price></item-filter-price>
            </div>
            <div v-else-if="facet.id == 'feedback'" v-show="isOpen">
            </div>
            <div v-else-if="facet.id == 'category' && isCatPageAndNotSearch" v-show="isOpen">
            </div>
            <div v-else-if="facet.id == 9 || facet.id == 5 || facet.id == 7" v-show="isOpen">
                <div class="filter__slider">
                    <div class="filter__slider-selection">
                        <span class="filter__slider-min">{{ currentMinValue }}</span> -
                        <span class="filter__slider-max">{{ currentMaxValue }}</span> mm
                    </div>
                    <vue-slider ref="dimensionSlider"
                                v-bind="sliderConfig"
                                v-model="sliderConfig.value"
                                :disabled="isLoading"
                                @drag-start="disableCallback"
                                @drag-end="enableCallback"
                                @change="filterDimension"
                                @callback="filterDimension">
                    </vue-slider>
                </div>
            </div>
            <div v-else class="filter__items" :class="{ 'filter__items-colors' : facet.id == 10 }" v-show="isOpen">
                <div class="filter__items-selection">
                    <span class="filter__items-selected">{{ selectedValue }}</span>
                </div>
                <div class="filter__items-values">
                    <div class="form-check" v-for="value in facets" :key="value.id">
                        <div v-if="facet.id == 10" class="filter__input-overlay" :class="{ 'is-active' : isSelected(value.id) }" @click="updateFacet(value)">
                            <div v-if="getMapping(value.id) == 'placeholder.jpg'" class="filter__input-overlay--inner" :style="'background-color: #' + value.cssClass.split('-')[1]"></div>
                            <div v-else class="filter__input-overlay--inner" :style="'background-image: url(https://www.weberbuero.de/documents/facet/'+facet.id+'/' + getMapping(value.id) + ')'"></div>
                        </div>
                        <input :id="'option-' + value.id" class="form-check-input styled-checkbox" type="checkbox" :checked="isSelected(value.id)" @change="updateFacet(value)" :disabled="isLoading || value.count <= 0">
                        <label :for="'option-' + value.id" class="form-check-label">
                            {{ value.name }}
                        </label>
                        <div class="filter-badge">{{ value.count }}</div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilterPrice from "~/app/components/itemList/filter/ItemFilterPrice.vue";
import TranslationService from "ceres/app/services/TranslationService";

export default {

    name: "item-filter",

    components:
    {
        ItemFilterPrice
    },

    props:
    {
        facet:
        {
            type: Object
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    data() {

        return {
            callbackBool: true,
            widthValues: [],
            facetValues: [],
            mappingArr: {91 : 'AD3', 101 : 'ABC'},
            initialSelectedFacets: [],
            selectedValues: [],
            sliderConfig: {
                value: [0, 5000],
                width: '100%',
                height: 4,
                dotWidth: 14,
                dotHeight: 14,
                speed: 1,
                min: 0,
                max: 5000,
                interval: 200,
                disabled: false,
                show: true,
                useKeyboard: true,
                tooltip: 'none',
                formatter: '{value}',
                mergeFormatter: '{value1} ~ {value2}',
                bgStyle: {
                    backgroundColor: '#e3e3e3',
                },
                processStyle: {
                    backgroundColor: '#3f3f3f',
                },
            },
            isOpen: false
        };
    },

    computed:
    {
        facets()
        {
            return this.facet.values;
        },

        isCatPageAndNotSearch(){
            return App.templateEvent == "tpl.category.item" && App.templateEvent !== "tpl.search";
        },

        showHeadline(){
            return this.facet.type === 'price' || (this.facet.type === 'category' && !this.isCatPageAndNotSearch) || Number.isInteger(this.facet.id);
        },

        currentSliderValue(){
            return this.sliderConfig.value;
        },

        currentMinValue(){
            return this.currentSliderValue[0];
        },

        currentMaxValue(){
            return this.currentSliderValue[1];
        },

        selectedValue(){
            let retString = TranslationService.translate("Weberbuero::Template.noSelection");

            if(this.selectedValues.length > 0){
                retString = '';
            }
            for(let key in this.selectedValues){
                if(key == 0){
                    retString += this.selectedValues[key];
                }else{
                    retString += ', ' + this.selectedValues[key];
                }
            }

            return retString;
        },

        facetName()
        {
            if (this.facet.translationKey && this.facet.translationKey.length > 0)
            {
                return this.$translate("Ceres::Template." + this.facet.translationKey);
            }

            return this.facet.name;
        },

        optionPreviewString(){
            return this.facet && this.facet.values.reduce((acc, next)=>acc + next.name + ", ", "").slice(0,-2);
        },

        ...mapState({
            selectedFacets: state => state.itemList.selectedFacets,
            isLoading: state => state.itemList.isLoading
        })
    },

    mounted(){
        let widthValues = [];
        let widthMin = 0;
        let widthMax = 0;

        this.initialSelectedFacets = this.selectedFacets;

        if(this.facet.id === 9 || this.facet.id === 7 || this.facet.id === 5){

            this.facetValues = this.facet.values;

            for(let key in this.facet.values){
                //widthValues.push({ id: this.facet.values[key].id, value:  parseInt(this.facet.values[key].name)});
                this.facet.values[key].name = parseInt(this.facet.values[key].name);
                widthValues.push(this.facet.values[key]);

                if(parseInt(this.facet.values[key].name) > widthMax){
                    widthMax = parseInt(this.facet.values[key].name);
                }

                if(parseInt(this.facet.values[key].name) < widthMin || widthMin === 0){
                    widthMin = parseInt(this.facet.values[key].name);
                }
            }

            this.widthValues = widthValues;

            this.sliderConfig.min = widthMin;
            this.sliderConfig.max = widthMax;

            let sliderFacetIsActive = false;
            let thisSliderInitialSelectedFacets = [];

            for(let key in this.initialSelectedFacets){
                if(this.getWidthIds().indexOf(this.initialSelectedFacets[key].id) > -1){
                    sliderFacetIsActive = true;
                    thisSliderInitialSelectedFacets.push(this.initialSelectedFacets[key]);
                    //break;
                }
            }

            if(thisSliderInitialSelectedFacets.length /*this.initialSelectedFacets.length*/ > 0 && sliderFacetIsActive){

                let minActive = 0;
                let maxActive = 0;

                for(let key in thisSliderInitialSelectedFacets/*this.initialSelectedFacets*/){
                    if(parseInt(thisSliderInitialSelectedFacets/*this.initialSelectedFacets*/[key].name) > maxActive){
                        maxActive = parseInt(thisSliderInitialSelectedFacets/*this.initialSelectedFacets*/[key].name);
                    }

                    if(parseInt(thisSliderInitialSelectedFacets/*this.initialSelectedFacets*/[key].name) < minActive || (minActive === 0 &&
                        parseInt(thisSliderInitialSelectedFacets/*this.initialSelectedFacets*/[key].name) !== 0)){
                        minActive = parseInt(thisSliderInitialSelectedFacets/*this.initialSelectedFacets*/[key].name);
                    }
                }

                this.sliderConfig.value = [minActive, maxActive];
            }else{
                this.sliderConfig.value = [widthMin, widthMax];
            }

        }

        let sliderFacetIsActive = false;
        let thisSliderInitialSelectedFacets = [];

        for(let key in this.initialSelectedFacets){
            if(this.getActiveFacetIds().indexOf(this.initialSelectedFacets[key].id) > -1){
                sliderFacetIsActive = true;
                thisSliderInitialSelectedFacets.push(this.initialSelectedFacets[key]);
            }
        }

        if(thisSliderInitialSelectedFacets.length > 0 && sliderFacetIsActive){
            for(let key in thisSliderInitialSelectedFacets){
                if(this.selectedValues.indexOf(thisSliderInitialSelectedFacets[key].name) === -1){
                    this.selectedValues.push(thisSliderInitialSelectedFacets[key].name);
                }
            }
        }

        if(this.selectedValue.length > 0 && this.selectedValue !== TranslationService.translate("Weberbuero::Template.noSelection")){
            this.selectedValues = this.selectedValue.split(', ');
        }

        if(this.facetName === "Farbe") this.isOpen = true;
    },

    methods:
    {
        updateFacet(facetValue)
        {
            window.localStorage.setItem("openFilterToolbar", true);
            this.$store.dispatch("selectFacet", { facetValue });
        },

        getMapping(facetValueId){
            let val =  this.mappingArr[facetValueId];

            if(typeof val !== 'undefined'){
                if(val.includes(" ")){
                    val = val.split(' ')[0];
                }

                let http = new XMLHttpRequest();
                val = val.toUpperCase();

                http.open('HEAD', 'https://www.weberbuero.de/documents/facet/'+this.facet.id+'/'+val+'.jpg', false);
                http.send();

                if(http.status == 404){
                    val = val.toLowerCase();
                }

                return val+'.jpg';
            }

            return 'placeholder.jpg';

        },

        isSelected(facetValueId)
        {
            return this.selectedFacets.findIndex(selectedFacet => selectedFacet.id === facetValueId) > -1;
        },

        disableCallback() {
            this.callbackBool = false;
        },
        enableCallback() {
            this.callbackBool = true;
            this.filterDimension();
        },
        selectAll(event) {
            event.target.select();
        },

        getWidthIds(){

            let retArr = [];

            for(let key in this.widthValues){
                retArr.push(this.widthValues[key].id)
            }

            return retArr;
        },

        getActiveFacetIds(){
            let retArr = [];

            for(let key in this.facet.values){
                retArr.push(this.facet.values[key].id)
            }

            return retArr;
        },

        getActiveWidthFacets(){
            let minSet = this.currentSliderValue[0];
            let maxSet = this.currentSliderValue[1];

            let widthValues = this.widthValues;
            let activeWidthValueIds = [];

            for(let key in widthValues){
                if(widthValues[key].name >= minSet && widthValues[key].name <= maxSet){
                    activeWidthValueIds.push(widthValues[key].id)
                }
            }
            return activeWidthValueIds;
        },

        getActiveFacetObjects(returnIdArray){
            let ids = this.getActiveWidthFacets();
            let retArr = [];

            for(let key in this.facetValues){
                if(ids.indexOf(this.facetValues[key].id) > -1){
                    retArr.push(this.facetValues[key])
                }
            }

            if(returnIdArray){
                return ids;
            }

            return retArr;
        },

        selectedFacetsToIdArray(initial){
            let idArr = [];

            if(initial){
                for(let key in this.initialSelectedFacets){
                    idArr.push(this.initialSelectedFacets[key].id);
                }
            }else{
                for(let key in this.selectedFacets){
                    idArr.push(this.selectedFacets[key].id);
                }
            }

            return idArr;
        },

        setSliderFacets(){

            let activeFacetObjects = this.getActiveFacetObjects(true);
            let widthValues = this.widthValues; // alles

            for(let key in widthValues){

                if(activeFacetObjects.indexOf(widthValues[key].id) > -1){
                    if(this.selectedFacetsToIdArray(false).indexOf(widthValues[key].id) < 0){
                        this.updateFacet(widthValues[key]);
                    }
                }else{
                    if(this.selectedFacetsToIdArray(false).indexOf(widthValues[key].id) > -1){
                        this.updateFacet(widthValues[key]);
                    }
                }

            }
            // this.selectedFacetsToIdArray(false)
            // this.updateFacet(activeFacetObjects[key]);
        },

        filterDimension() {
            this.setSliderFacets();
        },
    }
}
</script>
